import { render, staticRenderFns } from "./UsersPrivilegeReports.vue?vue&type=template&id=de51b73c&scoped=true&"
import script from "./UsersPrivilegeReports.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de51b73c",
  null
  
)

export default component.exports